<div class="otp-modal-backdrop">
  <div class="otp-modal-box shadow">
    <div class="otp-modal-header">
      <h5><i class="fas fa-shield-alt me-2 text-success"></i>Verify OTP</h5>
      <button class="btn-close" (click)="cancel()">&times;</button>
    </div>

    <div class="otp-modal-body">
      <p class="mb-3">Enter the 6-digit OTP sent to your mobile number.</p>

      <input
        type="text"
        maxlength="6"
        [(ngModel)]="otpCode"
        class="form-control text-center mb-3"
        placeholder="------"
      />

      <button class="btn btn-success w-100 mb-3" 
       (click)="verifyOtp()"
       [disabled]="otpCode.length !== 6 || isLoading">
        <i class="fas fa-check-circle me-1"></i> {{ isLoading ? 'Verifying...' : 'Verify' }}
      </button>


      <div class="text-center mb-3">
        <small class="text-muted">
          Didn’t receive the OTP?
          <button
            class="btn btn-link p-0 ms-1"
            [disabled]="resendCooldown > 0"
            (click)="resendOtp()"
          >
            Resend OTP
          </button>
          <span *ngIf="resendCooldown > 0" class="text-danger">
            ({{ resendCooldown }}s)
          </span>
        </small>
      </div>

      <button class="btn btn-outline-secondary w-100" (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
</div>
